import { render, staticRenderFns } from "./BlockStages.vue?vue&type=template&id=42fee5df&scoped=true&"
import script from "./BlockStages.vue?vue&type=script&lang=js&"
export * from "./BlockStages.vue?vue&type=script&lang=js&"
import style0 from "./BlockStages.vue?vue&type=style&index=0&id=42fee5df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fee5df",
  null
  
)

export default component.exports